<template>
    <v-container>
        <InfoAlert :showDismissibleAlert="showDismissibleAlert" :info="info"
            v-on:close="showDismissibleAlert = false" />
        <EnergyAnalysisReportLists :report="report" />
    </v-container>
</template>

<script>
import InfoAlert from "@/components/InfoAlert";
import EnergyAnalysisReportLists from "@/components/lists/EnergyAnalysisReportLists";
export default {
    name: "EnergyAnalysisReportDetails",
    props: ["report"],
    components: {
        InfoAlert,
        EnergyAnalysisReportLists
    },
    data() {
        return {
            file: "",
            showDismissibleAlert: false,
            info: '',
            isValid: false,
            loading: false,
            nameRules: [
                (v) => !!v || this.$store.getters.getTextMap().name_is_required,
                (v) => /\S+/.test(v) || this.$store.getters.getTextMap().name_is_required,
                (v) =>
                    (v && v.length <= 30 && v.length > 0) ||
                    this.$store.getters.getTextMap().name_must_be_less_than_30_characters,
            ],
            objectRules: [(v) => !!v || "Required"],
            showEdit: false
        };
    },
    computed: {

    },
    methods: {

    },

};
</script>

<style scoped></style>